<template>
  <hr class="block h-[1px] border-0 border-t border-solid border-tertiary-text opacity-50 my-1 mx-0 p-0" />
</template>
